import type { TreeRelation } from '@halo/utils';
import { toTree } from '@halo/utils';
import type { ActionKeys } from '@/configs/router/actions';
import type Paths from '@/configs/router/paths';
import type { Action, ActionMap, RouteItem, RouteMap, RouteMenuItem } from './types';

export function genActionMap(baseMap: Record<ActionKeys, Omit<Action, 'key'>>) {
  for (const k in baseMap) {
    if (!('key' in baseMap[k as ActionKeys])) {
      (baseMap as any)[k].key = k;
    }
  }
  return baseMap as ActionMap;
}

export function genRouteMap(baseMap: RouteMap) {
  for (const k in baseMap) {
    const item = baseMap[k as Paths];
    if (!('path' in item)) {
      item.path = k;
    }
  }
  return baseMap;
}

export function genMenu(relation: TreeRelation<RouteItem>) {
  return toTree(
    relation,
    ({ path, menu, auth }) =>
      ({
        key: path as string,
        auth,
        ...menu,
      }) as RouteMenuItem
  );
}

export function mergeRouteMap(baseMap: RouteMap, routeMap: RouteMap) {
  for (const k in baseMap) {
    const basRoute = baseMap[k as Paths];
    const route = routeMap[k as Paths];

    Object.assign(basRoute, route);

    if (route.handle) {
      Object.assign(basRoute.handle || {}, route.handle);
    }
  }
  return baseMap;
}
